import React, { useState, useEffect } from 'react';
import { Button, Checkbox, ConfigProvider, Form } from 'antd';
import { FormOutlined } from '@ant-design/icons';

interface RequestFeedbackFormProps {
  changesRequested?: {
    [key: string]: boolean; // Dynamic key-value pair for changes requested
  };
  isAdmin: boolean;
  completed: boolean;
}

const RequestFeedbackForm: React.FC<RequestFeedbackFormProps> = (props) => {
  const [changesRequested, setChangesRequested] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    // Set the state with the incoming props or default values
    setChangesRequested(props.changesRequested || {});
  }, [props.changesRequested]);

  const fieldLabels: { [key: string]: string } = {
    requestUpdatedCredentialDetails: 'Credential Details',
    requestUpdatedIssuingInstitution: 'Issuing Institution',
    requestUploadCredential: 'Credential Upload',
    requestUploadTranslation: 'Credential Translation',
    requestUpdatedPassportDetails: 'Passport Details',
    requestUploadExpirationPage: 'Passport Expiration',
    requestUploadPassportTranslation: 'Passport Translation',
    requestUploadPassport: 'Passport Upload',
    requestUploadPhoto: 'Passport Photo',
    requestScheduleNotaryCam: 'Notary Cam Schedule',
    requestUploadNotarizedIdForm: 'Notarized ID Form'
    // Add labels for any additional fields here
  };

  // Function to generate content based on changesRequested
  const generateContent = () => {
    return Object.keys(changesRequested)
      .map((key) => {
        if (changesRequested[key]) {
          return (
            <li key={key}>
              <b>{fieldLabels[key] || key}</b>
            </li>
          );
        }
        return null;
      })
      .filter((item) => item !== null);
  };

  const ScheduleNotaryCamForm = () => {
    const buttonStyling = {
      borderRadius: '2px',
      width: '60%',
      margin: '10px 5px'
    };
    return (
      <ConfigProvider
        theme={{
          components: {
            Form: {
              itemMarginBottom: 0
            }
          }
        }}
      >
        {!props.completed  ? (
          <Form disabled={true}>
            <b> Step 1: Schedule Session</b>
            <br />
            <Button style={{ ...buttonStyling, backgroundColor: '#DBFFC5' }}>
              <FormOutlined /> Schedule Session
            </Button>
            <br />
            <b> Step 2: When Session is Complete:</b>
            <br />
            <Form.Item style={{ margin: '5px 0px' }} valuePropName="checked">
              <Checkbox>I have completed my identity session</Checkbox>
            </Form.Item>
            <Form.Item>
              <Button style={{ ...buttonStyling, float: 'right', margin: '0px' }} type="primary">
                Complete Activity
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <>
            <p>Schedule NotaryCam Appointment</p>
            <Button disabled={true} style={{ ...buttonStyling, float: 'right', margin: '0px', width: '100%' }} type="primary">
              Schedule
            </Button>
          </>
        )}
      </ConfigProvider>
    );
  };

  const content = generateContent();

  const tabNamesInstructions = (() => {
    const hasNotarizedIdForm = props.changesRequested?.['requestUploadNotarizedIdForm'];
    const hasOtherChanges = Object.keys(props.changesRequested || {}).some((key) => key !== 'requestUploadNotarizedIdForm' && props.changesRequested?.[key]);

    if (hasNotarizedIdForm && hasOtherChanges) {
      return 'Files and Application';
    } else if (hasNotarizedIdForm) {
      return 'Files';
    } else {
      return 'Application';
    }
  })();

  return (
    <div
      style={{
        backgroundColor: 'white',
        paddingTop: '20px',
        paddingBottom: '40px',
        paddingLeft: '20px',
        paddingRight: '20px',
        margin: 10,
        textAlign: 'left',
        border: '1px solid #d9d9d9',
        borderRadius: '8px'
      }}
    >
      {changesRequested['requestScheduleNotaryCam'] === true ? (
        <ScheduleNotaryCamForm />
      ) : (
        <>
          {props.isAdmin ? `The applicant's application has been opened and can now update the:` : `Your application is unlocked, you can now update the:`}
          <br />
          <br />
          {content.length > 0 && (props.isAdmin ? <ul>{content}</ul> : <div>{content}</div>)}
          {props.isAdmin ? `in the ${tabNamesInstructions} tab.` : `in the ${tabNamesInstructions} tab above.`}
        </>
      )}
    </div>
  );
};

export default RequestFeedbackForm;
